import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { isBo } from '../../../../utils/CommonMethods'
import { ConfigContext } from '../../../../contexts/ConfigContext'
import * as actionType from '../../../../store/actions'
import packageJson from '../../../../../package.json'
import logoopencash from '../../../../assets/images/logoopencash.png'
import logoopencash_bo from '../../../../assets/images/cpi-logo-bo.png'

function NavLogo(appname) {
  const configContext = useContext(ConfigContext)
  const { collapseMenu } = configContext.state
  const { dispatch } = configContext

  let toggleClass = ['mobile-menu']
  if (collapseMenu) {
    toggleClass = [...toggleClass, 'on']
  }
  return (
    <div className="navbar-brand header-logo">
      <div className="b-brand">
        <img
          src={isBo() ? logoopencash_bo : logoopencash}
          alt="logo"
          width={isBo() ? 150 : 35}
          height={isBo() ? 150 : 35}
          style={{ objectFit: 'scale-down' }}
        />
        {!isBo() && <div className="b-title">{appname.appname}</div>}

        <br />
        <div className="b-version">v{packageJson.version}</div>
        {isBo() && (
          <div style={{ marginLeft: '60px' }} className="b-title px-5">
            {appname.customername}
          </div>
        )}
      </div>
      <Link
        to="#"
        className={toggleClass.join(' ')}
        id="mobile-collapse"
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          dispatch({ type: actionType.COLLAPSE_MENU })
        }}
      >
        <span />
      </Link>
    </div>
  )
}

export default NavLogo

